/*
 * Restock subscription submit handler, shared by the product page dialog
 * (kodama-restock.liquid) and the global card-bell dialog
 * (kodama-restock-modal.liquid).
 *
 * The dialogs used to post Shopify's native customer form, which created a
 * tagged customer and reloaded the page. They now POST JSON to the Firebase
 * `subscribe` function instead, so the page never navigates and the owner gets
 * a real per-product waiting list plus the demand ranking.
 *
 * The product id must be the numeric Shopify id ({{ product.id }}): the restock
 * webhook resolves inventory items to that same id, and if the two disagree
 * subscriptions are stored but nobody is ever emailed.
 */
(function () {
  var LOCAL = /^(127\.0\.0\.1|localhost)$/.test(window.location.hostname);
  var ENDPOINT = LOCAL
    ? 'http://127.0.0.1:15001/kodama1/us-central1/subscribe'
    : 'https://subscribe-ojs2syqpca-uc.a.run.app';

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('[data-restock-form]')) return;
    event.preventDefault();
    submitRestock(form);
  });

  function submitRestock(form) {
    var email = form.querySelector('[name="email"]');
    var honeypot = form.querySelector('[name="company"]');
    var submit = form.querySelector('[type="submit"]');
    var status = form.querySelector('[data-restock-status]');
    var root = form.closest('[data-restock-root]');
    var dialog = root && root.querySelector('[data-restock-dialog]');

    if (!email || !email.value) return;
    if (form.dataset.busy) return;
    form.dataset.busy = '1';
    if (submit) submit.disabled = true;
    setStatus(status, form.dataset.restockSending || '', '');

    fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: email.value,
        productId: form.dataset.restockProductId || '',
        productTitle: form.dataset.restockProductTitle || '',
        productUrl: form.dataset.restockProductUrl || '',
        productImage: absoluteImage(form),
        hp: honeypot ? honeypot.value : ''
      })
    })
      .then(function (res) {
        return res
          .json()
          .catch(function () { return {}; })
          .then(function (body) { return { ok: res.ok, body: body }; });
      })
      .then(function (result) {
        if (!result.ok || !result.body.ok) throw new Error('subscribe failed');
        // "already subscribed" is still a success from the shopper's point of
        // view, so it gets the same message rather than a correction.
        setStatus(status, form.dataset.restockSuccess || '', 'is-ok');
        email.value = '';
        // Long enough to actually read the confirmation before it vanishes.
        window.setTimeout(function () {
          if (dialog && dialog.open) dialog.close();
          setStatus(status, '', '');
        }, 6000);
      })
      .catch(function () {
        setStatus(status, form.dataset.restockError || '', 'is-error');
      })
      .then(function () {
        form.dataset.busy = '';
        if (submit) submit.disabled = false;
      });
  }

  /*
   * Liquid's image_url can yield a protocol-relative (//cdn...) or root-relative
   * (/cdn/shop/...) URL. Either is fine in a page and useless in an email, so
   * resolve it against the product URL, which Liquid always renders absolute
   * via shop.url. Using location.origin instead would embed http://127.0.0.1
   * when testing locally.
   */
  function absoluteImage(form) {
    var src = form.dataset.restockProductImage || '';
    if (!src) return '';
    if (/^https?:\/\//i.test(src)) return src;
    if (src.indexOf('//') === 0) return 'https:' + src;
    var productUrl = form.dataset.restockProductUrl || '';
    var match = productUrl.match(/^https?:\/\/[^/]+/i);
    if (!match) return '';
    return match[0] + (src.charAt(0) === '/' ? src : '/' + src);
  }

  function setStatus(el, text, state) {
    if (!el) return;
    el.textContent = text;
    el.className = 'krestock__status' + (state ? ' ' + state : '');
    el.hidden = !text;
  }

})();
